import React from 'react';
import { BrowserRouter as Router, Navigate, Route, Routes } from 'react-router-dom';
import Landing from './pages/Landing';
import Login from './pages/Login';
import Signup from './pages/Signup';
import Dashboard from './pages/Dashboard';
import AuthCallback from './pages/AuthCallback';
import RepJoin from './pages/RepJoin';
import RepDashboard from './pages/RepDashboard';
import RepAuthCallback from './pages/RepAuthCallback';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/login" element={<Login />} />
        <Route path="/signup" element={<Signup />} />
        <Route path="/dashboard" element={<Dashboard section="overview" />} />
        <Route path="/dashboard/summaries" element={<Dashboard section="summaries" />} />
        <Route path="/dashboard/team" element={<Dashboard section="team" />} />
        <Route path="/dashboard/billing" element={<Dashboard section="billing" />} />
        <Route path="/setup" element={<Navigate to="/dashboard" replace />} />
        <Route path="/dashboard/*" element={<Navigate to="/dashboard" replace />} />
        <Route path="/auth/callback" element={<AuthCallback />} />
        {/* Rep onboarding routes */}
        <Route path="/rep/join/:code" element={<RepJoin />} />
        <Route path="/rep/dashboard" element={<RepDashboard />} />
        <Route path="/rep/auth/callback" element={<RepAuthCallback />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Router>
  );
}

export default App;

